import { render, staticRenderFns } from "./NoCertificate.vue?vue&type=template&id=232ba4b6&scoped=true"
import script from "./NoCertificate.vue?vue&type=script&lang=js"
export * from "./NoCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ba4b6",
  null
  
)

export default component.exports